<template lang="pug">
  .row.center
    notifications.row.center(group='profile-edition' position='bottom' :width='500')
      template(slot='body' slot-scope='props')
        .row.middle(:class='{ error: isError }')
          simple-svg.white-stroke-icon.m4-right-4(:filepath='stopIcon' :width='"26px"' :height='"26px"')
          span.text-normal.white.bold
            | {{ item.message }}
    notifications.row.center(group='admin-team' position='bottom' :width='350')
      template(slot='body' slot-scope='props')
        .row.middle.default
          simple-svg.white-stroke-icon.m4-right-4(:filepath='iconToShow' :width='"26px"' :height='"26px"')
          span.text-normal.white.bold
            | {{ props.item.text }}
</template>

<script>
import stopIcon from '../../assets/ic_stop.svg'
import checkSaveIcon from '../../assets/ic_check_base.svg'
import userMultipleIcon from '../../assets/ic_user_multiple.svg'

export default {
  data () {
    return {
      stopIcon,
      checkSaveIcon,
      userMultipleIcon
    }
  },
  props: {
    item: { type: Object, required: true },
    isError: { type: Boolean },
    userIcon: { type: Boolean }
  },
  computed: {
    iconToShow() {
      return this.userIcon ? this.userMultipleIcon : this.checkSaveIcon
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/variables/colors';

%notification {
  box-shadow: 0 2px 8px 0 $shadow-gray1;
  border-radius: 5px;
  margin-bottom: 80px;
  min-height: 52px;
  padding: 12px 20px;
  text-align: center;
}

.default {
  @extend %notification;
  background-color: $blue;
  max-width: 330px;
}

.error {
  @extend %notification;
  background-color: $red;
  min-width: 500px;
}
</style>
